<template>
  <div class="search-filter">
    <AppInput
      v-model="value"
      type="search"
      placeholder="Search"
    />
  </div>
</template>

<script>
export default {
  name: 'ReportSearchFilter',
  computed: {
    value: {
      get() {
        return this.$store.getters.search;
      },
      set(search) {
        const newValue = search === '' ? null : search;

        this.$store.dispatch('updateSearch', { search: newValue });
      },
    },
  },
};
</script>
